import { render, staticRenderFns } from "./GiftCheckout.vue?vue&type=template&id=a50696ce"
import script from "./GiftCheckout.vue?vue&type=script&lang=js"
export * from "./GiftCheckout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports